// extracted by mini-css-extract-plugin
module.exports = {"box":"FormCheckbox_box__QYdxa","input":"FormCheckbox_input__3cFva","checkmark":"FormCheckbox_checkmark__3lOeR","label":"FormCheckbox_label__25d4S"};